import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
// Türkisch temporär deaktiviert
// import tr from './locales/tr.json';

const resources = {
  de: { translation: de },
  // Türkisch ausgeblendet für erste Version
  // tr: { translation: tr },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de', // Standard-Sprache: Deutsch
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
